module.exports = __webpack_public_path__ + "img/like.d2ec9555.gif";